import React from 'react'
import PropTypes from 'prop-types'
import { SectionSearch, Toolbar, ToolbarRow } from '../../../../components'

/**
 * Custom Contacts Toolbar
 * @param handleFilterChange
 * @returns {*}
 * @constructor
 */
const CustomContactToolbar = ({ handleFilterChange }) => {
  const handleSearchChange = (query) => handleFilterChange({ query, page: 1 })

  return (
    <Toolbar>
      <ToolbarRow justified>
        <div className='toolbar_group'>
          <SectionSearch
            className='toolbar_docked-element toolbar_docked-element--right'
            onQueryChange={handleSearchChange}
            onClear={handleSearchChange} />
        </div>
      </ToolbarRow>
    </Toolbar>
  )
}

CustomContactToolbar.propTypes = {
  handleFilterChange: PropTypes.func.isRequired
}

export default CustomContactToolbar
